import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap'
import { toggleCollapsedNav } from 'actions/Setting'
import UserInfo from 'components/UserInfo'
import Menu from 'components/Header/Menu'

class Header extends React.Component {

  onUserInfoSelect = () => {
    this.setState({
      userInfo: !this.state.userInfo
    })
  }

  onToggleCollapsedNav = (e) => {
    const val = !this.props.navCollapsed
    this.props.toggleCollapsedNav(val)
  }

  constructor () {
    super()
    this.state = {
      searchBox: false,
      searchText: '',
      mailNotification: false,
      langSwitcher: false,
      appNotification: false,
      userInfo: false

    }
  }

  render () {
    const {profile} = this.props.auth
    return (
      <div className={`app-main-header ${profile.impersonatedSession ? 'bg-warning' : null}`}>
        <div className="d-flex app-toolbar align-items-center">
            <div className="app-logo-bl">
              <div className="d-block d-md-none">
                <Link to={'specialist'}><img className="d-sm-block" alt='lingoowl logo' width={100} src='/vendors/lingoowl/lingoowl-logo.png'/>
                </Link>
                                {/*<span className="jr-menu-icon"*/}
                                      {/*onClick={this.onToggleCollapsedNav}>*/}
                                    {/*<span className="menu-icon"/>*/}
                                {/*</span>*/}
              </div>
              <div className="app-logo pointer d-none d-md-block">
                <img className="d-none d-lg-block" alt='LingoOwl logo' src='/vendors/lingoowl/lingoowl-logo.png'/>
              </div>
            </div>

          <Menu/>
          <ImpersonationMessage profile={profile} />
          <ul className="header-notifications list-inline ml-auto">
            <li className="list-inline-item user-nav">
              <Dropdown
                className="quick-menu"
                isOpen={this.state.userInfo}
                toggle={this.onUserInfoSelect.bind(this)}>

                <DropdownToggle
                  className="d-inline-block"
                  tag="span"
                  data-toggle="dropdown">
                  <i className="zmdi zmdi-account zmdi-hc-lg text-secondary pointer"/>
                </DropdownToggle>

                <DropdownMenu right>

                  <UserInfo profile={profile}/>
                </DropdownMenu>
              </Dropdown>

            </li>
          </ul>
        </div>
      </div>
    )
  }

}

const ImpersonationMessage = ({profile}) => profile.impersonatedSession
  ? <span className="nav-text bg-white rounded font-weight-bold p-3 ml-5">
    Acting on behalf of <b>{`${profile.firstName} ${profile.lastName}`}</b>
          </span>
  : null

const mapStateToProps = ({settings, auth}) => {
  const {drawerType, locale, navigationStyle, horizontalNavPosition} = settings
  return {drawerType, locale, navigationStyle, horizontalNavPosition, auth}
}

export default withRouter(connect(mapStateToProps, {toggleCollapsedNav})(Header))



// WEBPACK FOOTER //
// ./components/Header/index.js